<template>
  <v-app style="background-color:white">
    <div
      class="text-xs-center px-3"
      :class="{
        'custom-content-xs': $vuetify.breakpoint.xsOnly,
        'mt-5': $vuetify.breakpoint.smAndUp
      }"
    >
      <v-flex xs12 pb-3>
        <span>
          <img
            :src="require('../assets/logo.png')"
            height="40"
            style="margin-bottom:10px;"
          />
        </span>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <img :src="require('../assets/ic_scb.jpg')" height="60" />
      </v-flex>

      <div class="xs12 pb-3  subheading pb-2" style="color:#757575">
        Please wait for a while. Do not close the browser or refresh the page
      </div>

      <router-link to="/paymentSuccess">
        <div class="xs12  subheading" style="color:#757575">
          โปรดรอซักครู่ กรุณาอย่าปิดหน้าบราว์เซอร์ หรือทำการรีเฟรชหน้าจอเพจ
        </div>
      </router-link>
    </div>
  </v-app>
</template>

<script>
export default {}
</script>

<style scoped>
.custom-content-xs {
  margin: auto;
}
</style>
